import { RouteName, TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { push, useResolveRoute } from '@mews/routing';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { LinkMenu, ListOption } from '../../../components/commander-ui';

interface AdditionalServiceMenuProps {
    productServiceId: string;
}

const additionalServiceOptions: Array<ListOption> = [
    {
        value: RouteName.ProductIndex,
        primaryText: <LocalizedText textKey={TextKey.ProductPlural} />,
        iconName: undefined,
        shouldUseValueAsLink: false,
    },
    {
        value: RouteName.BusinessSegmentIndex,
        primaryText: <LocalizedText textKey={TextKey.BusinessSegmentPlural} />,
        iconName: undefined,
        shouldUseValueAsLink: false,
    },
    {
        value: RouteName.ServiceDocumentIndex,
        primaryText: <LocalizedText textKey={TextKey.ServiceDocumentPlural} />,
        iconName: undefined,
        shouldUseValueAsLink: false,
    },
    {
        value: RouteName.ProductServiceAccountingIndex,
        primaryText: <LocalizedText textKey={TextKey.Accounting} />,
        iconName: undefined,
        shouldUseValueAsLink: false,
    },
];

export const AdditionalServiceMenu = ({ productServiceId }: AdditionalServiceMenuProps) => {
    const resolveRoute = useResolveRoute();
    const dispatch = useCommanderThunkDispatch();

    const handleNavigation = (route: string) => {
        const isProductServiceAccountingIndex = (route as RouteName) === RouteName.ProductServiceAccountingIndex;
        if (isProductServiceAccountingIndex) {
            dispatch(push(resolveRoute(route, { id: productServiceId })));
        } else {
            dispatch(
                push(
                    resolveRoute(route, {
                        query: {
                            OwnerId: productServiceId,
                        },
                    })
                )
            );
        }
    };

    return (
        <LinkMenu
            nameKey={TextKey.Settings}
            options={additionalServiceOptions}
            handleNavigation={handleNavigation}
            selected=""
        />
    );
};
